import { AbstractControl, ValidationErrors } from '@angular/forms';
import { validateSocialSecurityNumber } from './validation-helper';

export const validateFormSocialSecurityNumber = (control: AbstractControl): ValidationErrors | null => {
  const isValid = validateSocialSecurityNumber(control?.value as string);
  if (!isValid) {
    return { socialSecurityNumber: true };
  }
  return null;
};
